import clsx from 'clsx';
import React from 'react';

type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  errors: any;
  label?: string;
  inputStyle?: InputStyles;
};

export enum InputStyles {
  Standard = 'standard',
  Outline = 'outline',
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ name, errors, label, inputStyle, ...props }, ref) => {
    const error = name && errors[name];

    const inputClasses = clsx(
      (inputStyle === InputStyles.Standard || !inputStyle) &&
        'w-full p-4 border bg-input-background rounded border-transparent',
      inputStyle === InputStyles.Outline &&
        'w-full p-3 border border-ice rounded',
      'focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2',
      {
        'border-red-500 focus:border-transparent': error,
      }
    );

    const labelClasses = clsx(
      'pb-1',
      (inputStyle === InputStyles.Standard || !inputStyle) && 'text-lg',
      inputStyle === InputStyles.Outline && 'font-family-semibold'
    );

    return (
      <div className="text-black">
        {label && (
          <label htmlFor={name} className={labelClasses}>
            {label}
          </label>
        )}
        <input
          {...props}
          name={name}
          ref={ref}
          aria-invalid={error ? true : false}
          className={inputClasses}
        />
        {error && (
          <div className="text-red-500" role="alert" id={`input-error-${name}`}>
            {error.message}
          </div>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
